import script from "./CouponPromoMembre.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponPromoMembre.vue?vue&type=script&setup=true&lang=js"

import "./CouponPromoMembre.vue?vue&type=style&index=0&id=1aa0dd16&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa0dd16"]])

export default __exports__